import dayjs from "dayjs";

export const getAlteredIdNumber = (idNumber: string): string => {
  // 1. 형식 검사: 13자리 숫자 또는 YYMMDD-SSSSSSS 형식인지 확인
  const formatRegex = /^\d{6}-\d{7}$|^\d{13}$/;
  if (!formatRegex.test(idNumber)) {
    return "-";
  }

  // 2. '-'가 없는 경우 '-'를 추가하여 뒷자리 처리 용이하게 함
  let processedIdNumber = idNumber;
  if (idNumber.length === 13 && !idNumber.includes("-")) {
    processedIdNumber = `${idNumber.slice(0, 6)}-${idNumber.slice(6)}`;
  }

  // 3. '-' 기준으로 앞부분과 뒷부분 분리
  const parts = processedIdNumber.split("-");
  if (parts.length !== 2 || parts[1].length !== 7) {
    // 형식이 맞지 않는 경우 (이전 검사에서 걸러져야 하지만 안전하게 처리)
    return "-";
  }

  const frontPart = parts[0];
  const backPartLength = parts[1].length;
  const maskedBackPart = "*".repeat(backPartLength);

  // 4. 앞부분과 마스크 처리된 뒷부분 결합하여 반환
  return `${frontPart}-${maskedBackPart}`;
};

export const getAgeFromIdNumber = (idNumber: string): number | null => {
  const formatRegex = /^\d{6}-\d{7}$|^\d{13}$/;
  if (!formatRegex.test(idNumber)) {
    return null;
  }

  let birthYearStr: string;
  let birthMonthStr: string;
  let birthDayStr: string;
  let genderDigit: string;

  if (idNumber.includes("-")) {
    birthYearStr = idNumber.substring(0, 2);
    birthMonthStr = idNumber.substring(2, 4);
    birthDayStr = idNumber.substring(4, 6);
    genderDigit = idNumber.substring(7, 8);
  } else {
    birthYearStr = idNumber.substring(0, 2);
    birthMonthStr = idNumber.substring(2, 4);
    birthDayStr = idNumber.substring(4, 6);
    genderDigit = idNumber.substring(6, 7);
  }

  let birthYear = parseInt(birthYearStr, 10);

  if (
    genderDigit === "1" ||
    genderDigit === "2" ||
    genderDigit === "5" ||
    genderDigit === "6"
  ) {
    birthYear = 1900 + birthYear;
  } else if (
    genderDigit === "3" ||
    genderDigit === "4" ||
    genderDigit === "7" ||
    genderDigit === "8"
  ) {
    birthYear = 2000 + birthYear;
  } else {
    return null;
  }

  const birthMonth = parseInt(birthMonthStr, 10) - 1;
  const birthDay = parseInt(birthDayStr, 10);

  const birthDate = dayjs(`${birthYear}-${birthMonth + 1}-${birthDay}`);
  const today = dayjs();

  let age = today.year() - birthDate.year();
  const monthDiff = today.month() - birthDate.month();

  if (monthDiff < 0 || (monthDiff === 0 && today.date() < birthDate.date())) {
    age--;
  }

  return age;
};

export const getAgeFromBirthDate = (birthDateStr: string): number | null => {
  if (dayjs(birthDateStr).isAfter(Date.now())) return null;
  // "YYYYMMDD" 또는 "YYYY-MM-DD" 허용
  const normalized = birthDateStr.replace(/-/g, "");
  const birthDateRegex = /^\d{8}$/;

  if (!birthDateRegex.test(normalized)) {
    return null;
  }

  const year = parseInt(normalized.substring(0, 4), 10);
  const month = parseInt(normalized.substring(4, 6), 10) - 1;
  const day = parseInt(normalized.substring(6, 8), 10);

  const birthDate = dayjs(new Date(year, month, day));
  if (!birthDate.isValid()) {
    return null;
  }

  const today = dayjs();
  let age = today.year() - birthDate.year();

  if (
    today.month() < birthDate.month() ||
    (today.month() === birthDate.month() && today.date() < birthDate.date())
  ) {
    age--;
  }

  return age;
};
